import React from 'react';
import { Dialog, Paper } from '@mui/material';
import Draggable from 'react-draggable';
import { CloseOutlined, DragIndicatorOutlined } from '@mui/icons-material';
// Draggable modal for past notes
function PaperComponent(props) {
    return (React.createElement(Draggable, { handle: "#draggable-icon", cancel: '[class*="MuiDialogContent-root"]', bounds: 'parent' },
        React.createElement(Paper, { style: { maxWidth: '700px' }, ...props })));
}
export const ConsentNotesDetails = (props) => {
    const { notes, onClose } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { hideBackdrop: true, open: true, onClose: onClose, PaperComponent: PaperComponent, disableEnforceFocus: true, style: { pointerEvents: 'none', marginRight: 'inherit' }, PaperProps: { style: { pointerEvents: 'auto', maxWidth: '700px', marginRight: 'inherit' } } },
            React.createElement("div", { style: { height: '100%', width: '675px' } },
                React.createElement("div", { className: 'flex p-2 items-center' },
                    React.createElement(DragIndicatorOutlined, { style: { cursor: 'move' }, id: 'draggable-icon' }),
                    React.createElement("div", { style: { fontFamily: 'Barlow', fontWeight: 400, width: '150px' } }, "Notes"),
                    React.createElement(CloseOutlined, { style: { marginLeft: 'auto', float: 'right', cursor: 'pointer' }, onClick: onClose })),
                React.createElement("div", { style: { display: 'grid', minHeight: '200px', margin: '25px', height: '100%', padding: '15px', borderWidth: 1, borderColor: '#0000001F', borderRadius: 3, alignContent: 'center' } }, notes)))));
};
